<template>
  <div>
    <tabs>
      <tab-pane :label="getBaseProperty('bike-stockwatch')">
        <notification-settings-stockwatch-grid
          :items="stockWatchBikeData.stockwatches || []"
          :base-properties="baseProperties"
          :no-item="noItem[0]"
          qaid="notification-settings-grid-stockwatch-bike"
          @update-data-list="fetchStockWatchBikeData"
        ></notification-settings-stockwatch-grid>
      </tab-pane>
      <tab-pane :label="getBaseProperty('acc-stockwatch')">
        <notification-settings-stockwatch-grid
          :items="stockWatchAftermarketData.stockwatches || []"
          :base-properties="baseProperties"
          :no-item="noItem[1]"
          qaid="notification-settings-grid-stockwatch-am"
          @update-data-list="fetchStockWatchAftermarketData"
        ></notification-settings-stockwatch-grid>
      </tab-pane>
      <tab-pane :label="getBaseProperty('bike-eta')">
        <notification-settings-eta-grid
          :items="EtaBikeData.orderLines || []"
          :token="token"
          :base-properties="baseProperties"
          :no-item="noItem[2]"
          qaid="notification-settings-grid-eta-bike"
          @update-data-list="fetchEtaBikeData"
        ></notification-settings-eta-grid>
      </tab-pane>
      <tab-pane :label="getBaseProperty('acc-eta')">
        <notification-settings-eta-grid
          :items="EtaAftermarketData.orderLines || []"
          :token="token"
          :base-properties="baseProperties"
          :no-item="noItem[3]"
          qaid="notification-settings-grid-eta-am"
          @update-data-list="fetchEtaAftermarketData"
        ></notification-settings-eta-grid>
      </tab-pane>
      <tab-pane :label="getBaseProperty('email-prefs')">
        <notification-settings-email-preferences
          :columns="notificationPrefsEmailData.columns"
          :groupings="notificationPrefsData"
        ></notification-settings-email-preferences>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import Tabs from '@/components/tabs/Tabs';
import TabPane from '@/components/tabs/TabPane';
import NotificationSettingsEtaGrid from '@/components/containers/my-account/NotificationSettingsEtaGrid';
import NotificationSettingsStockwatchGrid from '@/components/containers/my-account/NotificationSettingsStockwatchGrid';
import NotificationSettingsEmailPreferences from '@/components/containers/notifications/NotificationSettingsEmailPreferences';

export default {
  components: {
    Tabs,
    TabPane,
    NotificationSettingsEtaGrid,
    NotificationSettingsStockwatchGrid,
    NotificationSettingsEmailPreferences,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stockWatchBikeData: [],
      stockWatchAftermarketData: [],
      EtaBikeData: [],
      EtaAftermarketData: [],
      notificationPrefsEmailData: {},
      notificationPrefsData: [],
      noItemDefaultMessage: 'Sorry, you have no watched items to display',
      noItem: [],
    };
  },
  computed: {},

  mounted() {
    this.fetchStockWatchBikeData();
    this.fetchStockWatchAftermarketData();
    this.fetchEtaBikeData();
    this.fetchEtaAftermarketData();
    this.fetchNotificationPrefsEmailData();
  },
  methods: {
    /* Should probably put these fetchers in a loop */
    fetchStockWatchBikeData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data.stockwatches) {
            data.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
          }
          this.stockWatchBikeData = data;
          this.noItem[0] =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
        })
        .catch((error) => console.error(error));
    },
    fetchStockWatchAftermarketData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=am')
        .then(({data: {data, meta}}) => {
          if (data.stockwatches) {
            data.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
          }
          this.stockWatchAftermarketData = data;
          this.noItem[1] =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
        })
        .catch((error) => console.error(error));
    },
    fetchEtaBikeData() {
      return axios
        .get('/notification-settings/eta-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data.orderLines) {
            data.orderLines.forEach((element) => {
              Vue.set(element, 'checkboxActive', false);
              Vue.set(element, 'etaWatch', true);
            });
          }
          this.noItem[2] =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
          this.EtaBikeData = data;
        })
        .catch((error) => console.error(error));
    },
    fetchEtaAftermarketData() {
      return axios.get('/notification-settings/eta-watch?producttype=am').then(({data: {data, meta}}) => {
        if (data.orderLines) {
          data.orderLines.forEach((element) => {
            Vue.set(element, 'checkboxActive', false);
            Vue.set(element, 'etaWatch', true);
          });
        }
        this.noItem[3] =
          meta.feedback.message && meta.feedback.message != null
            ? meta.feedback.message.basePropertyValue
            : this.noItemDefaultMessage;
        this.EtaAftermarketData = data;
      });
    },
    fetchNotificationPrefsEmailData() {
      this.notificationPrefsEmailData = {
        columns: [
          {
            label: this.getBaseProperty('event'),
          },
          {
            label: this.getBaseProperty('online'),
            cssClasses: 'text-right',
          },
          {
            label: this.getBaseProperty('email'),
            cssClasses: 'text-right',
          },
        ],
      };
      return axios.get('notification-settings/user-preferences/').then(({data: {data}}) => {
        if (data) {
          this.notificationPrefsData = data;
        }
      });
    },
  },
};
</script>
